import { useState, useEffect } from 'react'
import {
    Box,
    Text,
    Flex,
    Image
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import avatar from '@olagg/ui-kit/svg/avatar_circle.svg'
import VerifiedTick from '../VerifiedTick'
import { cdn } from '@/utils/cloudflareCdn'

interface IUserAvatar {
    name: string;
    userId?: string | number;
    image?: string;
    fontSize?: any;
    fontWeight?: any;
    avatarWidth?: any;
    avatarHeight?: any;
    authorRole?: string,
    extraData?: any,
    color?: string
}

export default function UserAvatar({
    name,
    userId,
    image,
    fontSize = '14px',
    fontWeight = '600',
    avatarWidth = '24px',
    avatarHeight = '24px',
    authorRole = '',
    extraData,
    color = 'white'
}: IUserAvatar) {

    const [imgAvatar, setImgAvatar] = useState(avatar)

    useEffect(() => {
        if (image) setImgAvatar(image)
    }, [image])


    return (
        <Flex alignItems={'center'} gap='4px'>
            <Flex>
                <Box
                    position={'relative'}
                    width={avatarWidth}
                    height={avatarHeight}
                >
                    <Image
                        border={'1px solid #4E10FF'}
                        fallbackSrc={avatar}
                        width={avatarWidth}
                        height={avatarHeight}
                        src={imgAvatar}
                        // src={cdn(imgAvatar, { w: avatarWidth, h: avatarHeight })}
                        objectFit={'cover'} borderRadius='50%'
                        backgroundColor='purple'
                    />
                </Box>
            </Flex>
            <Flex direction={{ base: 'column', md: 'row' }} w='100%'>
                <Flex alignItems={'center'} gap='4px'>
                    {userId ? (
                        <Link to={`/users/${userId}`}>
                            <Text noOfLines={1} fontSize={fontSize} fontWeight={fontWeight} color={color} position='relative' top='2px'>{name}</Text>
                        </Link>
                    ) : (
                        <>
                            <Text noOfLines={1} fontSize={fontSize} fontWeight={fontWeight} color={color} position='relative' top='2px'>{name}</Text>
                        </>
                    )}
                    <VerifiedTick authorRole={authorRole} />
                </Flex>
                {extraData}
            </Flex>
        </Flex>
    )
}
